import React from 'react'
import PropTypes from 'prop-types'
import {Tooltip} from 'antd'
import {DASH, formatPercent} from '../../helpers/format'

/**
 * Nhãn phần trăm của hai chỉ số chất lượng dữ liệu.
 *
 * ⚠️ `null` hiện dấu gạch — KHÔNG hiện 0% và cũng không hiện 100% (BR-A13). Mẫu số bằng 0 nghĩa là
 *    "không áp dụng" (tài khoản không làm In, Cắt, Khắc), khác hẳn "đạt 0%". Hiện 0% làm người đọc
 *    tưởng dữ liệu hỏng; hiện 100% làm họ tưởng đã đủ.
 *
 * ⚠️ Dưới ngưỡng thì vẫn hiện số kèm cảnh báo, không ẩn số (UI-D06): ẩn số làm người dùng tưởng
 *    hệ thống hỏng.
 *
 * Hai chỉ số này luôn ở hai cột riêng, không gộp (UI-02) — hai nguyên nhân khác nhau, hai bộ phận
 * xử lý khác nhau.
 */
function PercentTag({ratio, kind, digits}) {
    if (ratio === null || ratio === undefined) {
        return <span className="VcPercent VcPercent--na">{DASH}</span>
    }

    const percent = Number(ratio) * 100

    let tone = 'ok'

    if (kind === 'fileData') {
        // Chỉ số dữ liệu file in: xanh khi 100%, tím khi dưới 100% (M17 §5.4).
        tone = percent >= 100 ? 'ok' : 'file'
    } else if (percent < 90) {
        tone = 'bad'
    } else if (percent < 100) {
        tone = 'warn'
    }

    return (
        <Tooltip title={kind === 'fileData'
            ? 'Tỷ lệ item đã có diện tích in và đường cắt. Thiếu thì Designer / File operator đi xử lý'
            : 'Tỷ lệ item tra ra được định mức. Thiếu thì IE / Trưởng khu vực đi xử lý'}
        >
            <span className={`VcPercent VcPercent--${tone}`}>{formatPercent(ratio, digits)}</span>
        </Tooltip>
    )
}

PercentTag.propTypes = {
    ratio: PropTypes.number,
    kind: PropTypes.oneOf(['standard', 'fileData']).isRequired,
    digits: PropTypes.number,
}

export default PercentTag
